"use client";

import { Trigger } from "@radix-ui/react-select";
import { useParams } from "next/navigation";
import { useTransition } from "react";

import { SUPPORTED_LOCALES } from "@trip/constants";

import { GlobeIcon } from "~/components/icons/globe-icon";
import { Select, SelectContent, SelectItem } from "~/components/ui/select";
import { usePathname, useRouter } from "~/navigation";

import { LoadingSpinner } from "./loading-spinner";

export function LocalePicker({
  currentLocale,
}: {
  currentLocale: (typeof SUPPORTED_LOCALES)[number];
}) {
  const [isPending, startTransition] = useTransition();
  const router = useRouter();
  const pathname = usePathname();
  const params = useParams();

  return (
    <Select
      onValueChange={(value) => {
        startTransition(() => {
          router.replace(
            // @ts-expect-error -- TypeScript will validate that only known `params`
            // are used in combination with a given `pathname`. Since the two will
            // always match for the current route, we can skip runtime checks.
            { pathname, params },
            { locale: value, scroll: false },
          );
        });
      }}
      value={currentLocale}
    >
      <Trigger aria-label="Language">
        {isPending ? (
          <LoadingSpinner className="size-5 text-neutral-500" />
        ) : (
          <GlobeIcon />
        )}
      </Trigger>
      <SelectContent align="center">
        {SUPPORTED_LOCALES.map((locale) => (
          <SelectItem key={locale} value={locale} className="text-right">
            {locale === "en" ? "English" : null}
            {locale === "ja" ? "日本語" : null}
            {locale === "ko" ? "한국어" : null}
            {locale === "th" ? "ไทย" : null}
            {locale === "zh-CN" ? "中文" : null}
            {locale === "zh-TW" ? "中文（臺灣）" : null}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
